import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseCompetingAdsComponent } from '../../abstract-components/base-competing-ads.component';

@Component({
  selector: 'competing-ads-layout',
  standalone: false,
  templateUrl: './competing-ads-layout.component.html',
  styleUrl: './competing-ads-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetingAdsLayoutComponent extends BaseCompetingAdsComponent {}
